<script setup>

import {MapboxLayer} from "@studiometa/vue-mapbox-gl";

const props = defineProps({
	'features': Array,
	'set': String,
});

const emit = defineEmits(['selectMarker']);

const selectMarker = function(marker){
	const clickedMarkers = marker.features;
	const selectedMarker = clickedMarkers[0];

	emit('selectMarker', selectedMarker);
}


</script>

<template>
	<MapboxLayer
			:id="`meetresultaten-${set}`"
			v-if="features.length"
			:options="{
          type: 'symbol',
          source: {
            type: 'geojson',
            cluster: false,
            data: {
							id: `meetresultaten-data-${set}`,
							type: 'FeatureCollection',
							crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
							features: features
						},
          },
          layout: {
							'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
							'text-size': 12,

							'symbol-placement': 'point',
							'symbol-z-order': 'source',
							'icon-anchor': 'bottom',
							'icon-allow-overlap': true,

							'icon-image': `watermonsters-marker-score-${set}`,
						 },
					}"
			@mb-click="selectMarker"
	/>
</template>

<style scoped>

</style>